module.exports = __webpack_public_path__ + "img/carve-up-coefficient@2x.720a044d.svg";